import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { environment } from 'environment';

@Directive({ selector: '[tenTokenizerMessageListener]', standalone: true })
export class TokenizerMessageListenerDirective {
  @Output() public tokenizerMessage: EventEmitter<any>;

  @HostListener('window:message', ['$event'])
  public onMessage(event: MessageEvent<any>) {
    if (environment.tokenizerUrl.startsWith(event.origin)) {
      this.tokenizerMessage.next(event);
    }
  }

  constructor() {
    this.tokenizerMessage = new EventEmitter();
  }
}
